import React from 'react'
import TabsProvider from '../tabs-provider'

const ShowCurriculum = ({ params: { curriculumId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
      tabs={[{
        label: 'Edit Curriculum',
        path: `/events/curriculums/${curriculumId}/edit`
      }, {
        label: 'Webinars',
        path: `/events/curriculums/${curriculumId}/webinars`
      }]}
    />
    {children}
  </div>
)

export default ShowCurriculum
